<template>
    <div class="homepage">
        <div class="profile-header">
            <div class="avatar" @click="chooseImage">
                <img v-if="userInfo.img" :src="userInfo.img" class="avatar-img" />
                <van-icon v-else name="user-circle-o" size="32" color="#1565C0" />
            </div>
            <div class="profile-info">
                <div class="profile-name" @click="editUserName">{{ userInfo.name }}<van-icon name="edit"
                        class="edit-icon" /></div>
                <div class="profile-username">{{ userInfo.account }}</div>
            </div>

            <!-- 编辑用户名弹窗 -->
            <van-popup v-model="showEditNamePopup" position="center" round>
                <div class="popup-content">
                    <h3>编辑用户名</h3>
                    <van-field v-model="editName" placeholder="请输入新的用户名" maxlength="20" />
                    <div class="popup-buttons">
                        <van-button type="default" @click="showEditNamePopup = false">取消</van-button>
                        <van-button type="primary" @click="updateUserName" style="background: #1565C0;">确定</van-button>
                    </div>
                </div>
            </van-popup>
        </div>

        <!-- 统计卡片：三列，中间有竖线 -->
        <div class="stats-row">
            <div class="stat-item">
                <div class="stat-value">{{ summaryData.reportCount }}</div>
                <div class="stat-label">企业数量</div>
            </div>
            <div class="stat-item stat-item-center">
                <div class="stat-value">{{ summaryData.loanCount }}</div>
                <div class="stat-label">贷后记录</div>
            </div>
            <div class="stat-item">
                <div class="stat-value">{{ summaryData.unreadMessageCount }}</div>
                <div class="stat-label">未读消息</div>
            </div>
        </div>

        <!-- 菜单列表：自定义样式，与设计稿一致 -->
        <div class="menu-card">
            <div v-for="(item, index) in menuItems" :key="item.id" class="menu-item"
                :class="{ 'menu-item--last': index === menuItems.length - 1 }" @click="onMenuClick(item)">
                <div class="menu-icon-wrap" :style="{ backgroundColor: item.color + '15' }">
                    <van-icon :name="item.vanIcon" size="18" :color="item.color" />
                </div>
                <span class="menu-label" :class="{ 'menu-label--danger': item.id === 'logout' }">{{ item.label }}</span>
                <div class="menu-right">
                    <span v-if="item.id === 'message' && summaryData.unreadMessageCount > 0" class="badge">{{
                        summaryData.unreadMessageCount }}</span>
                    <van-icon v-if="item.id !== 'logout'" name="arrow" class="menu-arrow" />
                </div>
            </div>
        </div>

        <van-tabbar v-model="active">
            <van-tabbar-item to="/credit/home" icon="wap-home">首页</van-tabbar-item>
            <van-tabbar-item icon="contact">我的</van-tabbar-item>
        </van-tabbar>
    </div>
</template>

<script>
import { user } from "@/store/index";
import { mapState } from "pinia"; //引入映射函数
import useCache from "@/utils/user";
import { Toast } from 'vant';
import request from "@/utils/request";

export default {
    data() {
        return {
            active: 1,
            summaryData: {
                reportCount: 0,
                loanCount: 0,
                unreadMessageCount: 0
            },
            showEditNamePopup: false,
            editName: '',
            menuItems: [
                { id: 'enterprise', vanIcon: 'records-o', label: '企业管理', route: '/credit/enterpriseManage?t=0', color: '#1565C0' },
                { id: 'loan', vanIcon: 'balance-list-o', label: '企业贷后', route: '/credit/customerManage?loanType=1', color: '#00897B' },
                { id: 'loan', vanIcon: 'balance-list-o', label: '个人贷后', route: '/credit/customerManage?loanType=0', color: '#00897B' },
                { id: 'message', vanIcon: 'bell', label: '消息管理', route: '/credit/message', color: '#F57C00' },
                { id: 'password', vanIcon: 'lock', label: '修改密码', route: '/credit/changePassword?source=credit', color: '#7B1FA2' },
                { id: 'logout', vanIcon: 'revoke', label: '退出登录', route: null, color: '#C62828' },
            ],
        }
    },
    created() {
        this.getMySummary();
    },
    computed: {
        ...mapState(user, ["userInfo"]),
    },
    methods: {
        onMenuClick(item) {
            if (item.id === 'logout') {
                this.handleLogOut()
            } else if (item.route) {
                this.$router.push(item.route)
            }
        },
        // 获取个人汇总数据
        getMySummary() {
            request.get('/Common/Dashboard/MySummary')
                .then((res) => {
                    if (res.data && res.data.data) {
                        this.summaryData = res.data.data;
                    }
                })
                .catch((error) => {
                    console.error('获取汇总数据失败:', error);
                });
        },
        handleLogOut() {
            Toast("退出登录成功");
            useCache.clearToken();
            this.$router.replace({
                path: '/credit/login',
                query: { source: 'credit' }
            })

        },
        // 选择图片
        chooseImage() {
            // 创建隐藏的文件输入框
            const input = document.createElement('input');
            input.type = 'file';
            input.accept = 'image/*';
            input.onchange = (e) => {
                const file = e.target.files[0];
                if (file) {
                    this.uploadLocalImage({ file });
                }
            };
            input.click();
        },
        // 上传本地图片
        uploadLocalImage(file) {
            Toast.loading({
                message: '正在上传...',
                forbidClick: true,
            });

            // 调用后端接口上传图片
            const formData = new FormData();
            formData.append('id', 0);
            formData.append('file', file.file);

            request.post("/Common/File/UploadFile", formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then((res) => {
                Toast.clear();
                console.log('保存图片成功:', res);
                if (res.data && res.data.data) {
                    this.updateUserImg(process.env.VUE_APP_BASE_API.replace('/api', '') + res.data.data)
                } else {
                    Toast('头像更新失败，请重试');
                }
            }).catch((error) => {
                Toast.clear();
                console.error('保存图片失败:', error);
                Toast('头像更新失败，请重试');
            });
        },
        // 编辑用户名
        editUserName() {
            // 初始化编辑框的值为当前用户名
            this.editName = this.userInfo.name || '';
            // 显示弹窗
            this.showEditNamePopup = true;
        },
        // 更新用户名
        updateUserName() {
            // 验证输入
            if (!this.editName.trim()) {
                Toast('请输入用户名');
                return;
            }

            Toast.loading({
                message: '正在更新...',
                forbidClick: true,
            });

            // 调用后端接口更新用户信息
            request.post("/User/AccountMng/UpdateMyInfo", {
                name: this.editName.trim(),
                img: this.userInfo.img || ''
            }).then((res) => {
                Toast.clear();
                console.log('更新用户信息成功:', res);
                if (res.data && res.data.code === 0) {
                    // 更新本地用户信息
                    this.userInfo.name = this.editName.trim();

                    useCache.cacheUserData(this.userInfo)
                    Toast('用户名更新成功');
                    // 关闭弹窗
                    this.showEditNamePopup = false;
                } else {
                    Toast('用户名更新失败，请重试');
                }
            }).catch((error) => {
                Toast.clear();
                console.error('更新用户信息失败:', error);
                Toast('用户名更新失败，请重试');
            });
        },
        // 更新用户头像
        updateUserImg(filePath) {
            Toast.loading({
                message: '正在更新...',
                forbidClick: true,
            });

            // 调用后端接口更新用户信息
            request.post("/User/AccountMng/UpdateMyInfo", {
                name: this.userInfo.name,
                img: filePath
            }).then((res) => {
                Toast.clear();
                console.log('更新用户信息成功:', res);
                if (res.data && res.data.code === 0) {
                    // 更新用户头像
                    this.userInfo.img =filePath;

                    useCache.cacheUserData(this.userInfo)
                    Toast('头像更新成功');
                } else {
                    Toast('头像更新失败，请重试');
                }
            }).catch((error) => {
                Toast.clear();
                console.error('更新用户信息失败:', error);
                Toast('用户名更新失败，请重试');
            });
        }
    }
}
</script>

<style lang="less" scoped>
.homepage {
    background: #F0F4FF;
    padding: 16px 16px;
    min-height: 100vh;
    /* 防止微信黑暗模式影响 */
    color-scheme: light;
    -webkit-color-scheme: light;
}

/* 顶部蓝色区域：与设计稿一致 */
.profile-header {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 24px;
    margin: 0;
    border-radius: 20px;
    background: linear-gradient(135deg, #0D47A1 0%, #1565C0 50%, #1976D2 100%);
}

.avatar {
    width: 72px;
    height: 72px;
    flex-shrink: 0;
    border-radius: 50%;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 3px solid rgba(255, 255, 255, 0.4);
    overflow: hidden;
}

.avatar-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.profile-info {
    flex: 1;
    min-width: 0;
}

.profile-name {
    font-size: 22px;
    font-weight: 700;
    color: #fff;
    margin-bottom: 2px;
    line-height: 1.2;
}

.profile-username {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.75);
    margin-bottom: 8px;
    line-height: 1.2;
}

.vip-badge {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 20px;
    padding: 4px 10px;
    border: 1px solid rgba(255, 215, 0, 0.4);
    font-size: 12px;
    font-weight: 600;
    color: #FFD700;
}

/* 统计卡片：白底、圆角、阴影，中间一列有竖线 */
.stats-row {
    display: flex;
    background: #fff;
    margin: 16px 0px;
    border-radius: 16px;
    padding: 16px 0;
    box-shadow: 0 4px 12px rgba(21, 101, 192, 0.12);
}

.stat-item {
    flex: 1;
    text-align: center;
    padding: 4px 0;
}

.stat-item-center {
    border-left: 1px solid #EEF1FA;
    border-right: 1px solid #EEF1FA;
}

.stat-value {
    font-size: 22px;
    font-weight: 700;
    color: #1565C0;
    margin-bottom: 2px;
    line-height: 1.2;
}

.stat-label {
    font-size: 12px;
    color: #5B6B8A;
    line-height: 1.2;
}

/* 菜单卡片：白底、圆角、阴影，每行图标+文字+箭头/角标 */
.menu-card {
    background: #fff;
    margin-top: 16px;
    margin-bottom: 60px;
    border-radius: 20px;
    overflow: hidden;
    box-shadow: 0 4px 16px rgba(21, 101, 192, 0.12);
}

.menu-item {
    display: flex;
    align-items: center;
    padding: 16px 20px;
    gap: 14px;
    cursor: pointer;
    transition: background 0.15s;
    border-bottom: 1px solid #EEF1FA;
}

.menu-item:hover {
    background: #F5F7FF;
}

.menu-item--last {
    border-bottom: none;
}

.menu-icon-wrap {
    width: 38px;
    height: 38px;
    flex-shrink: 0;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.menu-label {
    flex: 1;
    font-size: 15px;
    font-weight: 500;
    color: #0D1B3E;
    text-align: left;
}

.menu-label--danger {
    color: #C62828;
}

.menu-right {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
}

.menu-arrow {
    color: #9DAAC0;
    font-size: 16px;
}

.badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 20px;
    height: 20px;
    padding: 0 6px;
    border-radius: 10px;
    background: #C62828;
    color: #fff;
    font-size: 11px;
    font-weight: 700;
}

.cell-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
}

.unread-badge {
    background-color: #ff4444;
    color: #ffffff;
    font-size: 0.7rem;
    padding: 0.1rem 0.4rem;
    border-radius: 180px;
    min-width: 1.0rem;
    text-align: center;
    margin-left: 0.5rem;
}

/* 确保 van-cell-group 在黑暗模式下也显示为白色 */
:deep(.van-cell-group) {
    background: #ffffff;
}

/* 确保 van-cell 在黑暗模式下也显示为白色 */
:deep(.van-cell) {
    background: #ffffff;
    color: #333;
}

/* 确保 van-tabbar 在黑暗模式下也显示为白色 */
:deep(.van-tabbar) {
    background: #ffffff;
}

:deep(.van-tabbar-item) {
    color: #666;
}

:deep(.van-tabbar-item--active) {
    color: #3a71ff;
}

/* 编辑用户名弹窗样式 */
.popup-content {
    padding: 24px;
    width: 90%;
    min-width: 250px;
}

.popup-content h3 {
    margin: 0 0 20px 0;
    font-size: 18px;
    font-weight: 600;
    color: #333;
    text-align: center;
}

.popup-buttons {
    display: flex;
    gap: 12px;
    margin-top: 24px;
}

.popup-buttons .van-button {
    flex: 1;
}

/* 使 profile-name 可点击 */
.profile-name {
    cursor: pointer;
    transition: opacity 0.2s;
    display: flex;
    align-items: center;
    gap: 8px;
}

.profile-name:hover {
    opacity: 0.8;
}

.edit-icon {
    font-size: 16px;
    color: rgba(255, 255, 255, 0.85);
}
</style>